import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/CarenuityLogoTransparent.png'


const _hoisted_1 = { class: "modern-footer" }
const _hoisted_2 = { class: "footer-main" }
const _hoisted_3 = { class: "footer-container" }
const _hoisted_4 = { class: "footer-section" }
const _hoisted_5 = { class: "footer-links" }
const _hoisted_6 = { class: "footer-section" }
const _hoisted_7 = { class: "footer-links" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "footer-bottom" }
const _hoisted_11 = { class: "footer-container" }
const _hoisted_12 = { class: "footer-bottom-content" }
const _hoisted_13 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "footer-section brand-section" }, [
          _createElementVNode("div", { class: "footer-logo" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Carenuity",
              class: "logo-img"
            })
          ]),
          _createElementVNode("p", { class: "brand-tagline" }, " Carenuity provides modular and highly customizable sensor solutions for monitoring vital signs and real estate air quality. ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "footer-title" }, "Quick Links", -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "footer-link"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Dashboard", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/alarms",
                class: "footer-link"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Alarms", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/devices",
                class: "footer-link"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Devices", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "footer-link"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Settings", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "https://www.chipglobe.shop/en",
                target: "_blank",
                rel: "noopener noreferrer",
                class: "footer-link"
              }, "Shop")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "footer-title" }, "Resources", -1)),
          _createElementVNode("ul", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "https://www.carenuity.com",
                target: "_blank",
                rel: "noopener noreferrer",
                class: "footer-link"
              }, "About Carenuity")
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "https://www.carenuity.com/contact-us/",
                target: "_blank",
                rel: "noopener noreferrer",
                class: "footer-link"
              }, "Contact Us")
            ], -1)),
            _cache[10] || (_cache[10] = _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "https://www.carenuity.com/sq-panel/",
                target: "_blank",
                rel: "noopener noreferrer",
                class: "footer-link"
              }, "SQ-Panel")
            ], -1)),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.germanManualUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "footer-link",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, "SQ-Panel Manual (DE)", 8, _hoisted_8)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: _ctx.englishManualUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "footer-link",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, "SQ-Panel Manual (EN)", 8, _hoisted_9)
            ])
          ])
        ]),
        _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"footer-section\" data-v-2b95dc9c><h3 class=\"footer-title\" data-v-2b95dc9c>Get in Touch</h3><ul class=\"footer-contact\" data-v-2b95dc9c><li class=\"contact-item\" data-v-2b95dc9c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b95dc9c><path d=\"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z\" data-v-2b95dc9c></path></svg><a href=\"mailto:info@carenuity.com\" class=\"footer-link\" data-v-2b95dc9c>info@carenuity.com</a></li><li class=\"contact-item\" data-v-2b95dc9c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b95dc9c><path d=\"M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z\" data-v-2b95dc9c></path></svg><a href=\"tel:+498912224694\" class=\"footer-link\" data-v-2b95dc9c>(+49) 89-1222469-40</a></li><li class=\"contact-item\" data-v-2b95dc9c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b95dc9c><path d=\"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z\" data-v-2b95dc9c></path></svg><span data-v-2b95dc9c>Munich, Germany</span></li></ul></div><div class=\"footer-section\" data-v-2b95dc9c><h3 class=\"footer-title\" data-v-2b95dc9c>Follow Us</h3><div class=\"social-links\" data-v-2b95dc9c><a href=\"https://www.linkedin.com/company/carenuity\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"social-link\" aria-label=\"LinkedIn\" data-v-2b95dc9c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b95dc9c><path d=\"M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z\" data-v-2b95dc9c></path></svg></a><a href=\"https://twitter.com/carenuity\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"social-link\" aria-label=\"Twitter\" data-v-2b95dc9c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b95dc9c><path d=\"M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z\" data-v-2b95dc9c></path></svg></a><a href=\"https://github.com/carenuity\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"social-link\" aria-label=\"GitHub\" data-v-2b95dc9c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-2b95dc9c><path d=\"M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z\" data-v-2b95dc9c></path></svg></a></div></div>", 2))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, " © " + _toDisplayString(_ctx.currentYear) + " Chipglobe GmbH. All rights reserved. Carenuity is a registered trademark of Chipglobe GmbH. ", 1),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "footer-bottom-links" }, [
            _createElementVNode("a", {
              href: "https://www.carenuity.com/privacy-policy/",
              target: "_blank",
              rel: "noopener noreferrer",
              class: "bottom-link"
            }, "Privacy Policy"),
            _createElementVNode("span", { class: "separator" }, "•"),
            _createElementVNode("a", {
              href: "https://www.carenuity.com/terms-of-service/",
              target: "_blank",
              rel: "noopener noreferrer",
              class: "bottom-link"
            }, "Terms of Service")
          ], -1))
        ])
      ])
    ])
  ]))
}